export function filterNegativeNumber(value: number, fallbackValue: number = 0): number {
  if (value < 0) {
    return fallbackValue;
  }

  return value;
}
